import React, { Component } from 'react';
import App from '../App';
import { GameModes } from '../models/GameModes';
import { GameState } from '../models/GameState';
import { PlayerState } from '../models/PlayerState';

interface IState {
	gameState: GameState;
}

interface IProps {
	app: App;
	connection: signalR.HubConnection;
	gameId: string;
}

class AdminPanel extends Component<IProps, IState> {
	
	private connection: signalR.HubConnection;

	constructor(props: IProps) {
		super(props);

		this.connection = props.connection;

		this.state = {
			gameState: {
				id: props.gameId,
				mode: GameModes.None,
				players: []
			}
		}
	}

	componentDidMount() {
		
		// bind connection events
		this.connection.on("gameStateChanged", this.onGameStateChanged);
	}

	onGameStateChanged = (gameState: GameState) => {
		this.setState({ gameState });
	}

	startAction(gameMode: GameModes) {
		this.connection.send("setGameMode", gameMode);
	}

	getCurrentModeString() {
		const { gameState } = this.state;
		switch (gameState.mode) {
			case GameModes.None:
				return "Idle";
			case GameModes.FourForEach:
				return "Four for each";
			case GameModes.FirstToPress:
				return "First to press";
		}
		return "Idle";
	}

	render() {
		const { gameState } = this.state;

		return (
			<div className="admin-panel">
				<h3>Game { gameState.id }</h3>
				<h3>
					<span>Current mode: </span>
					<span>{this.getCurrentModeString()}</span>
				</h3>
				<div className="actions">
					<h3>Actions:</h3>
					<div>
						<a className="nice-button" onClick={() => this.startAction(GameModes.FourForEach)}>Start FourForEach</a>
						<a className="nice-button" onClick={() => this.startAction(GameModes.FirstToPress)}>Start FirstPress</a>
						<a className="nice-button" onClick={() => this.startAction(GameModes.None)}>Stop</a>
					</div>
				</div>
				<div className="players-list">
					<h3>Players:</h3>
					<div>
						{
							gameState.players.map(p => (
								<div>
									<span>{p.name} - </span>
									{
										p.state === PlayerState.Ready
											? <span>{p.response}</span>
											: <span>Waiting...</span>
									}
								</div>
							))
						}
					</div>
				</div>
			</div>
		);
	}
}

export default AdminPanel;
